import { all, fork } from "redux-saga/effects"

//public
import AccountSaga from "./auth/register/saga"
import AuthSaga from "./auth/login/saga"
import ForgetSaga from "./auth/forgetpwd/saga"
import ProfileSaga from "./auth/profile/saga"
import LayoutSaga from "./layout/saga"
import ecommerceSaga from "./e-commerce/saga"
import calendarSaga from "./calendar/saga"
import chatSaga from "./chat/saga"
import cryptoSaga from "./crypto/saga"
import invoiceSaga from "./invoices/saga"
import projectsSaga from "./projects/saga"
import tasksSaga from "./tasks/saga"
import mailsSaga from "./mails/saga"
import contactsSaga from "./contacts/saga"
import dashboardSaga from "./dashboard/saga"
import dashboardSaasSaga from "./dashboard-saas/saga"
import timesheetSaga from "./timesheet/saga"
import teamsSaga from "./Teams/saga"
import trackprofilesage from "./trackprofile/saga"
import accessgroupage from "./accessgroupsetting/saga"
import userlistage from "./userlist/saga"
import createteamsage from "./createTeam/saga"
import manageclientage from "./manageclient/saga"
import categoryusersreport from "./workreport/saga"
import webHooks from "./webHooks/saga"
import WorkfromHome from "./workFromHome/saga"
import ScrutinyNote from "./ScrutinyNotes/saga"
import Caculateincentive from "./CalculateIncentive/saga"
import aiInvoiceSaga from "./aiinvoice/saga"
import reportSubmittedTimeSaga from "./reportSubmittedTime/saga"

export default function* rootSaga() {
  yield all([
    //public
    fork(AccountSaga),
    fork(AuthSaga),
    fork(ForgetSaga),
    fork(ProfileSaga),
    fork(LayoutSaga),
    fork(ecommerceSaga),
    fork(calendarSaga),
    fork(chatSaga),
    fork(mailsSaga),
    fork(cryptoSaga),
    fork(invoiceSaga),
    fork(projectsSaga),
    fork(tasksSaga),
    fork(contactsSaga),
    fork(dashboardSaga),
    fork(dashboardSaasSaga),
    fork(timesheetSaga),
    fork(teamsSaga),
    fork(trackprofilesage),
    fork(accessgroupage),
    fork(userlistage),
    fork(createteamsage),
    fork(manageclientage),
    fork(categoryusersreport),
    fork(webHooks),
    fork(WorkfromHome),
    fork(ScrutinyNote),
    fork(Caculateincentive),
    fork(aiInvoiceSaga),
    fork(reportSubmittedTimeSaga),
  ])
}
